import React from "react";
import { useTheme, Paper } from "@mui/material";

export interface CardProps {
  children: JSX.Element | JSX.Element[];
  disableVerticalPadding?: boolean;
  square?: boolean;
  dark?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  disableVerticalPadding = false,
  square = false,
  dark = false,
}) => {
  const theme = useTheme();

  return (
    <Paper
      style={{
        padding: `${theme.spacing(4)}${!disableVerticalPadding ? ` ${theme.spacing(3)}` : " 0"}`,
      }}
      square={square}
      {...(dark
        ? {
            sx: {
              bgcolor: "grey.900",
              "& .MuiTypography-root": { color: "white" }, // only Typography is white
              "& .MuiInputBase-root": { color: "inherit" }, // TextField text uses theme
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white", // keep input boxes white
              },
            },
          }
        : {})}
    >
      {children}
    </Paper>
  );
};

export default Card;
